<template>
    <div class="header_content bg-gray-700">
        <div class="header_content_info_content">
            <div class="header_content_info container-xl">
                <div class="header_content_info_row row">
                    <div class="col-xl-7 col-lg-12 d-flex justify-content-center p-0">
                        <BannerSlider :slides="banners" />
                    </div>
                    <div class="col-xl-5 col-lg-12 header_content_info_col header_content_info_forms">
                        <div class="header_content_info_calculate_block w-100 d-block align-items-start flex-column">
                            <h2 class="header_content_info_forms_title">
                                Рассчитать предварительную стоимость
                            </h2>
                            <div class="header_content_info_calculate_forms_block w-100 justify-content-between">
                                <div
                                    v-on-click-outside="handleClickOutsideSuggestDropdownFrom"
                                    :class="{
                                        'front-direction-field-new_control-wrapper': true,
                                        'loading loading--small': transportationRateLoading,
                                    }"
                                >
                                    <select-input
                                        v-model="calculateSumForms.from"
                                        class="header_content_info_calculate_form_input_size"
                                        :label="calculateForm?.fields[1].content"
                                        :options="citiesFrom"
                                        :update="getTariff"
                                    />
                                    <div
                                        class="front-direction-field-new_dropdown"
                                        :style="{
                                            display: calculateSumForms.fromHidden || shipFromHints.length === 0 ? 'none' : undefined,
                                        }"
                                    >
                                        <div class="front-direction-field-new_dropdown-inner">
                                            <div class="scroll-container-root">
                                                <ul class="front-suggest-new_suggest-list">
                                                    <template v-for="(hint, hintIndex) in shipFromHints" :key="hintIndex">
                                                        <li class="front-suggest-new_suggest-list__item" @click="handleSelectCalculateFrom(hint.value)">
                                                            <div class="front-suggest-new_suggest-list__item-title">
                                                                {{ hint.text }}
                                                            </div>
                                                            <div class="front-suggest-new_suggest-list__item-text">
                                                                {{ hint.value }}
                                                            </div>
                                                        </li>
                                                    </template>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <img
                                    class="header_content_info_calculate_form_icons"
                                    :class="{ loading: isCalculation }"
                                    src="@/assets/images/arrow_double.svg"
                                    alt=""
                                    @click="updateСalculation(calculateSumForms.to, calculateSumForms.from)"
                                />

                                <div
                                    v-on-click-outside="handleClickOutsideSuggestDropdownTo"
                                    :class="{
                                        'front-direction-field-new_control-wrapper': true,
                                        'loading loading--small': transportationRateLoading,
                                    }"
                                >
                                    <select-input
                                        v-model="calculateSumForms.to"
                                        class="header_content_info_calculate_form_input_size"
                                        :label="calculateForm?.fields[2].content"
                                        :options="citiesTo"
                                        :update="getTariff"
                                    />
                                    <div
                                        class="front-direction-field-new_dropdown"
                                        :style="{
                                            display: calculateSumForms.toHidden || shipToHints.length === 0 ? 'none' : undefined,
                                        }"
                                    >
                                        <div class="front-direction-field-new_dropdown-inner">
                                            <div class="scroll-container-root">
                                                <ul class="front-suggest-new_suggest-list">
                                                    <template v-for="(hint, hintIndex) in shipToHints" :key="hintIndex">
                                                        <li class="front-suggest-new_suggest-list__item" @click="handleSelectCalculateTo(hint.value)">
                                                            <div class="front-suggest-new_suggest-list__item-title">
                                                                {{ hint.text }}
                                                            </div>
                                                            <div class="front-suggest-new_suggest-list__item-text">
                                                                {{ hint.value }}
                                                            </div>
                                                        </li>
                                                    </template>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="header_content_info_calculate_forms_block w-100 justify-content-between">
                                <new-default-input-number v-model="calculateSumForms.weight" type="number" label="Вес, кг" class="header_content_info_calculate_form_input_size" :update="getTariff()" />
                                <new-default-input-number v-model="calculateSumForms.volume" type="number" label="Объём, м&sup3;" :decimal-places="2" class="header_content_info_calculate_form_input_size" :update="getTariff()" />
                            </div>
                            <div class="header_content_info_calculate_forms_block w-100 justify-content-between description-price">
                                <div v-if="!hasError">
                                    <p class="price-text mb-2" v-html="getPrice"></p>
                                    <p class="price-text mb-0" v-html="getDays"></p>
                                </div>
                                <div  class="w-50 message-block" v-else>
                                    <p class="price-text mb-0">{{ errorMessage }}</p>
                                </div>
                                <ConsultationBlock :show-phone="false" size="medium" />
                            </div>

                            <div>
                                <input type="hidden" name="addressFrom" :value="calculateSumForms.from" />
                                <input type="hidden" name="addressTo" :value="calculateSumForms.to" />
                            </div>
                        </div>
                        <div class="header_content_info_calculate_forms_block w-100 justify-content-between">
                            <p class="calc_desc">
                                Расчет цены услуг по организации перевозки груза автомобильным транспортом является предварительным.
                                Итоговая цена услуг рассчитывается исходя из фактических габаритов и свойств груза,
                                а также перечня заказанных услуг.
                                Уточнить актуальные тарифы и сроки Вы можете по телефону +7 (727) 346-77-77
                                и в отделениях ПЭК
                            </p>
                        </div>
                    </div>
                </div>
                <div class="header_content_advantages_block">
                    <div v-for="(itemList, itemIndex) in calculateForm?.list" :key="itemIndex" class="header_content_advantages d-flex align-items-start justify-content-start">
                        <div class="header_content_advantages_info_block">
                            <div class="header_content_advantages_number_block">
                                <div class="header_content_advantages_number">
                                    <div class="d-flex gap-1 h-100 content-text-advantages">
                                        <div class="d-flex gap-1 h-100 content-text-advantages-spans">
                                            <span>{{ itemList.number.split(' ')[0] }}</span>
                                            <span class="header_content_advantages_number_postfix">
                                                {{ itemList.number.split(' ')[1] }}
                                            </span>
                                        </div>
                                        <div class="icon-plus-container d-flex"></div>
                                    </div>
                                </div>
                            </div>
                            <div class="header_content_advantages_text_block">
                                <p class="header_content_advantages_text">
                                    {{ itemList.content }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import newDefaultInputNumber from '~~/components/Input/NewDefaultInputNumber.vue';
import selectInput from '~~/components/Input/SelectInput.vue';
import defaultButton from '~~/components/Button/DefaultButton.vue';
import { watchDebounced } from '@vueuse/core';
import { useContentPages } from '~~/stores/homeStores';
import { vOnClickOutside } from '@vueuse/components';
import { onMounted } from 'vue';
import { ocrGetAsync } from '~~/api/contentInfo/ocr/ocr';
import { getSugggest } from '@/pages/index/utils/getSugggest';
import { getNeedCalculate } from '@/pages/index/utils/getNeedCalculate';
import BannerSlider from '~/pages/index/components/BannerSlider.vue';
import { useTranslateLayOut } from '~/stores/translateStore.ts';
import { useLang } from '~/stores/langStore';
import tariffs from '/upload/tariffs_kz_022026_min.json';
import ConsultationBlock from '~/pages/index/components/ConsultationBlock.vue';

const props = defineProps({
    helpers: {
        type: Object,
    },
    calculateForm: {
        type: Object,
    },
    banners: {
        type: Object,
    },
});
const rateTenge = 5.5;

const langStore = useLang();
const contentPagesStore = useContentPages();
const translateStore = useTranslateLayOut();
const translateData = computed(() => translateStore.translateData);
const data = computed(() => contentPagesStore.consultationTranslate);

const searchFormCodeResult = reactive({
    success: '',
    text: translateData.value?.cargo_search_placeholder?.value || 'Введите код чтобы найти груз',
});

const searchFormCodeLoading = ref(false);
const shipFromHints = ref([]);
const shipToHints = ref([]);
const transportationRate = ref(null);
const transportationRateLoading = ref(false);
const isCalculation = ref(false);
let hasFields = ref(true);
let hasError = ref(true);
let errorMessage = ref('');
let citiesFrom = ref([]);
let citiesTo = ref([]);
let calculateSumForms = reactive({
    from: props.helpers?.city_from || { id: 1, value: 'Астана' },
    fromHidden: true,
    to: props.helpers?.city_to || { id: 2, value: 'Москва (ЦКАД)' },
    toHidden: true,
    weight: props.helpers?.weight.value || 5,
    volume: props.helpers?.volume.value || 0.01,
});

const swapPlaceValue = (to, from) => {
    let result = {};
    const replace = to;
    to = from;
    from = replace;
    result = {
        to: to,
        from: from,
    };
    return result;
};

const swapPlaceCites = async (to, from) => {
    const result = swapPlaceValue(to, from);
    calculateSumForms.to = result.to;
    calculateSumForms.from = result.from;
};

const handleClickOutsideSuggestDropdownFrom = e => {
    const isWrapper = e.target.matches('.front-direction-field-new_control-wrapper, .front-direction-field-new_control-wrapper *');

    if (isWrapper === false) {
        calculateSumForms.fromHidden = true;
    }
};

const handleClickOutsideSuggestDropdownTo = e => {
    const isWrapper = e.target.matches('.front-direction-field-new_control-wrapper, .front-direction-field-new_control-wrapper *');

    if (isWrapper === false) {
        calculateSumForms.toHidden = true;
    }
};

const getUniqueCityList = (key) => {
    const cities = [...new Set(tariffs.map(item => item[key]))].sort();
    return cities.map((value, index) => ({ id: index + 1, value }));
};

const getTariff = () => {
    hasError = false;
    hasFields = !!calculateSumForms.volume && calculateSumForms.volume > 0 && !!calculateSumForms.weight && calculateSumForms.weight > 0;
    if (!hasFields) {
        hasError = true;
        switch (langStore.langCode) {
            case 'ru':
                errorMessage = 'Для расчета стоимости заполните поля выше';
                break;
            case 'kk':
                errorMessage = 'Есептеу үшін өрістерді толтырыңыз';
                break;
            case 'en':
                errorMessage = 'To calculate the cost, please fill in the fields above';
                break;
        }
        return;
    }
    const idTariff = tariffs.findIndex(item => item.from === calculateSumForms.from.value && item.to === calculateSumForms.to.value);

    if (idTariff !== -1) {
        hasError = false;
        errorMessage = '';
        return tariffs[idTariff];
    } else {
        hasError = true;
        switch (langStore.langCode) {
            case 'ru':
                errorMessage = 'Данный маршрут не доступен к рассчёту. Попробуйте выбрать другие города Казахстана';
                break;
            case 'kk':
                errorMessage = 'Бұл бағыт есептеуге қол жетімді емес. Қазақстанның басқа қалаларын таңдауға тырысыңыз';
                break;
            case 'en':
                errorMessage = 'This route is not available for calculation. Try to choose other cities in Kazakhstan';
                break;
        }
    }
    return {
        tariff: 0,
    };
};

const getPrice = computed(() => {
    const tariff = getTariff();
    const arrayPrices = [];

    if (tariff) {
        if (calculateSumForms.weight <= 35 && calculateSumForms.volume <= 0.14) {
            if (calculateSumForms.weight <= 1 && calculateSumForms.volume <= 0.03) {
                arrayPrices.push(tariff['do1kgDo0.03m3']);
            }
            if (calculateSumForms.weight > 1 && calculateSumForms.weight <= 3 && calculateSumForms.volume <= 0.03) {
                arrayPrices.push(tariff['do3kgDo0.03m3']);
            }
            if (calculateSumForms.weight > 3 && calculateSumForms.weight <= 5 && calculateSumForms.volume <= 0.03) {
                arrayPrices.push(tariff['do5kgDo0.03m3']);
            }
            if (calculateSumForms.weight > 5 && calculateSumForms.weight <= 15 || calculateSumForms.volume > 0.03 && calculateSumForms.volume <= 0.08) {
                arrayPrices.push(tariff['do15kgDo0.08m3']);
            }
            if (calculateSumForms.weight > 15 && calculateSumForms.weight <= 35 || calculateSumForms.volume > 0.08 && calculateSumForms.volume <= 0.14) {
                arrayPrices.push(tariff['do35kgDo0.14m3']);
            }
        } else {
            arrayPrices.push(tariff['min']);
            if (calculateSumForms.weight > 35 && calculateSumForms.weight <= 100) {
                arrayPrices.push(calculateSumForms.weight * tariff['do100kg']);
            }
            if (calculateSumForms.weight > 100 && calculateSumForms.weight <= 200) {
                arrayPrices.push(calculateSumForms.weight * tariff['do200kg']);
            }
            if (calculateSumForms.weight > 200 && calculateSumForms.weight <= 300) {
                arrayPrices.push(calculateSumForms.weight * tariff['do300kg']);
            }
            if (calculateSumForms.weight > 300 && calculateSumForms.weight <= 400) {
                arrayPrices.push(calculateSumForms.weight * tariff['do400kg']);
            }
            if (calculateSumForms.weight > 400 && calculateSumForms.weight <= 500) {
                arrayPrices.push(calculateSumForms.weight * tariff['do500kg']);
            }
            if (calculateSumForms.weight > 500 && calculateSumForms.weight <= 700) {
                arrayPrices.push(calculateSumForms.weight * tariff['do700kg']);
            }
            if (calculateSumForms.weight > 700 && calculateSumForms.weight <= 1000) {
                arrayPrices.push(calculateSumForms.weight * tariff['do1000kg']);
            }
            if (calculateSumForms.weight > 1000 && calculateSumForms.weight <= 1500) {
                arrayPrices.push(calculateSumForms.weight * tariff['do1500kg']);
            }
            if (calculateSumForms.weight > 1500 && calculateSumForms.weight <= 2000) {
                arrayPrices.push(calculateSumForms.weight * tariff['do2000kg']);
            }
            if (calculateSumForms.weight > 2000 && calculateSumForms.weight <= 2500) {
                arrayPrices.push(calculateSumForms.weight * tariff['do2500kg']);
            }
            if (calculateSumForms.weight > 2500 && calculateSumForms.weight <= 3000) {
                arrayPrices.push(calculateSumForms.weight * tariff['do3000kg']);
            }
            if (calculateSumForms.weight > 3000) {
                arrayPrices.push(calculateSumForms.weight * tariff['ot3000kg']);
            }
            if (calculateSumForms.volume >= 0.14 && calculateSumForms.volume <= 0.4) {
                arrayPrices.push(calculateSumForms.volume * tariff['do0.4m3']);
            }
            if (calculateSumForms.volume > 0.4 && calculateSumForms.volume <= 0.8) {
                arrayPrices.push(calculateSumForms.volume * tariff['do0.8m3']);
            }
            if (calculateSumForms.volume >= 0.8 && calculateSumForms.volume <= 1.1) {
                arrayPrices.push(calculateSumForms.volume * tariff['do1.1m3']);
            }
            if (calculateSumForms.volume > 1.1 && calculateSumForms.volume <= 1.5) {
                arrayPrices.push(calculateSumForms.volume * tariff['do1.5m3']);
            }
            if (calculateSumForms.volume > 1.5 && calculateSumForms.volume <= 1.8) {
                arrayPrices.push(calculateSumForms.volume * tariff['do1.8m3']);
            }
            if (calculateSumForms.volume > 1.8 && calculateSumForms.volume <= 2.5) {
                arrayPrices.push(calculateSumForms.volume * tariff['do2.5m3']);
            }
            if (calculateSumForms.volume > 2.5 && calculateSumForms.volume <= 3.6) {
                arrayPrices.push(calculateSumForms.volume * tariff['do3.6m3']);
            }
            if (calculateSumForms.volume > 3.6 && calculateSumForms.volume <= 5.5) {
                arrayPrices.push(calculateSumForms.volume * tariff['do5.5m3']);
            }
            if (calculateSumForms.volume > 5.5 && calculateSumForms.volume <= 7.5) {
                arrayPrices.push(calculateSumForms.volume * tariff['do7.5m3']);
            }
            if (calculateSumForms.volume > 7.5 && calculateSumForms.volume <= 10) {
                arrayPrices.push(calculateSumForms.volume * tariff['do10m3']);
            }
            if (calculateSumForms.volume > 10 && calculateSumForms.volume <= 15) {
                arrayPrices.push(calculateSumForms.volume * tariff['do15m3']);
            }
            if (calculateSumForms.volume > 15) {
                arrayPrices.push(calculateSumForms.volume * tariff['ot15m3']);
            }
        }
    }
    const max = Math.round(Math.max(...arrayPrices));
    const priceRub = new Intl.NumberFormat('ru-RU', { minimumFractionDigits: 0 }).format(max);
    const priceTenge = new Intl.NumberFormat('kk-KZ', { minimumFractionDigits: 0 }).format(max * rateTenge);

    let priceRubWords = [];
    let currencyTenge = '';
    let aboutWord = '';
    switch(langStore.langCode) {
        case 'ru':
            priceRubWords = ['рубль', 'рубля', 'рублей'];
            currencyTenge = 'тенге';
            aboutWord = 'От ';
            break;
        case 'kk':
            priceRubWords = ['rub', 'rub', 'rub'];
            currencyTenge = 'теңге';
            aboutWord = 'От ';
            break;
        case 'en':
            priceRubWords = ['rub', 'rub', 'rub'];
            currencyTenge = 'tenge';
            aboutWord = 'From ';
            break;
    }

    return `${aboutWord} <b>${priceTenge} ${currencyTenge}</b> / <b>${priceRub} ${declineWord(priceRub, priceRubWords)}</b>`;
});

const declineWord = (number, words) => {
    number = Math.abs(number) % 100;
    const n1 = number % 10;

    if (number > 10 && number < 20) return words[2];
    if (n1 > 1 && n1 < 5) return words[1];
    if (n1 === 1) return words[0];

    return words[2];
};

const getDays = computed(() => {
    const tariff = getTariff();
    const days = tariff['days'];
    let dayWords = [];
    let aboutWord = '';
    switch(langStore.langCode) {
        case 'ru':
            dayWords = ['день', 'дня', 'дней'];
            aboutWord = 'Примерно ';
            break;
        case 'kk':
            dayWords = ['күн', 'күн', 'күн'];
            aboutWord = 'Шамамен';
            break;
        case 'en':
            dayWords = ['day', 'days', 'days'];
            aboutWord = 'About ';
            break;
    }
    return `${aboutWord} <b>${days} ${declineWord(days, dayWords)}</b>`;
});

const handleSelectCalculateFrom = v => {
    calculateSumForms.from = v;
    calculateSumForms.fromHidden = true;
};

const handleSelectCalculateTo = v => {
    calculateSumForms.to = v;
    calculateSumForms.toHidden = true;
};

const checkNeedCalculate = async () => {
    if (calculateSumForms?.from?.value?.trim() === '' || calculateSumForms?.to?.value?.trim() === '') {
        return;
    }
    transportationRateLoading.value = true;
    transportationRate.value = await getNeedCalculate(calculateSumForms.to.value, calculateSumForms.from.value);
    transportationRateLoading.value = false;
};

const updateStatusCalculation = status => {
    isCalculation.value = status;
};

const updateСalculation = (to, from) => {
    updateStatusCalculation(true);
    swapPlaceCites(to, from);
    updateStatusCalculation(false);
};

watchDebounced(
    () => calculateSumForms.from,
    async value => {
        shipFromHints.value = await getSugggest(value);
    },
    {
        debounce: 200,
    }
);

watchDebounced(
    () => calculateSumForms.to,
    async value => {
        shipToHints.value = await getSugggest(value);
    },
    {
        debounce: 200,
    }
);

onMounted(() => {
    citiesFrom.value = getUniqueCityList('from');
    citiesTo.value = getUniqueCityList('to');
    checkNeedCalculate();
});
</script>

<style>
.header_content_info_calculate_form_icons:hover {
    cursor: pointer;
    filter: invert(59%) sepia(57%) saturate(2936%) hue-rotate(211deg) brightness(104%) contrast(106%);
}

.header_content_info_forms_title {
    font-weight: 500;
    font-size: 20px;
    line-height: 28px;
    margin-bottom: 28px;
}

.front-direction-field-new_control-wrapper {
    position: relative;
    display: flex;
    flex-flow: column nowrap;
    background-color: #fff;
    flex: 1 1 100%;
}

.front-direction-field-new_control-wrapper .front-direction-field-new_dropdown {
    position: absolute;
    z-index: 0;
    width: 100%;
    left: 0;
    top: 100%;
    padding: 0.5rem 0 1rem;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #e4e6e7;
    -webkit-box-shadow: 0 4px 16px hsla(0, 0%, 82%, 0.25);
    box-shadow: 0 4px 16px hsla(0, 0%, 82%, 0.25);
    border-radius: 3px;
}

.front-direction-field-new_dropdown {
    z-index: 1000 !important;
}

.front-direction-field-new_control-wrapper .front-direction-field-new_dropdown-inner {
    margin-right: 8px;
    max-height: 396px;
}

.front-suggest-new_suggest-list {
    z-index: 100;
    padding: 0;
    margin: 0;
}

.front-suggest-new_suggest-list__item {
    display: block;
    width: 100%;
    padding: 0.5rem 1rem;
    font-size: 14px;
    text-align: left;
    border: none;
    outline: 0;
    background: #fff;
    cursor: pointer;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}

.front-suggest-new_suggest-list__item-title {
    color: #000;
}

.front-suggest-new_suggest-list__item-title span {
    color: #e4003c;
}

.front-suggest-new_suggest-list__item-text {
    color: #9a9a9a;
}

.front-suggest-new_suggest-list__item:hover .front-suggest-new_suggest-list__item-text,
.front-suggest-new_suggest-list__item:hover .front-suggest-new_suggest-list__item-title,
.front-suggest-new_suggest-list__item:hover .front-suggest-new_suggest-list__item-title span {
    color: #968eff;
}

.header_content_info_calculate_forms_block {
    display: flex;
    margin-bottom: 24px;
    gap: 10px;
}



.header_content_info_content {
    margin-top: 40px;
}

.header_content_advantages_block {
    display: flex;
    gap: 40px;
    margin-top: 35px;
    margin-bottom: 120px;
}

.header_content_advantages_info_block {
    display: flex;
    border-top: 1px solid #e4e6e7;
}

.header_content_advantages_number_block {
    font-size: 32px;
    margin-right: 24px;
    color: #e4003c;
}

.header_content_info_calculate_block {
    border-radius: 20px;
    gap: 28px;
    padding: 32px;
    box-shadow: 0px 0px 12px 0px rgba(95, 124, 151, 0.25);
}

.header_content_advantages_number {
    font-size: 48px;
    font-weight: 400;
    display: flex;
}

.header_content_info_calculate_button:hover .header_content_advantages_number_icons {
    background: #000 !important;
}

.header_content_advantages_number_postfix {
    font-size: 32px;
    height: auto;
}
.content-text-advantages {
    align-items: flex-start;
    vertical-align: text-top;
    display: flex;
}
.content-text-advantages-spans {
    align-items: baseline;
}
.icon-plus-container:after {
    content: '+';
    font-size: 32px;
}

.header_content_advantages_text {
    font-size: 18px;
    line-height: 26px;
    height: 100%;
    margin: 0;
    display: flex;
    text-align: left;
    align-items: center;
}

.header_content_info_calculate_form_icons {
    cursor: pointer;
}

p.calc_desc {
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    color: #aaa;
    margin-top: 20px;
}
.description-price {
    max-height: 56px;
}
.price-text {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #757575;
}
.price-text b {
    font-weight: 700;
    color: #000;
}
.message-block {
    max-width: 224px;
}
@media (max-width: 1199px) {
    .header_content_info_content {
        margin-top: 10px;
    }

    .header_content_info_calculate_block {
        margin-top: 50px;
    }

    .front-direction-field-new_control-wrapper {
        width: 100%;
    }
}

@media (max-width: 1159px) {
    .header_content_advantages_info_block {
        display: block;
    }

    .header_content_advantages_number_block {
        margin: 0 0 24px;
    }
}

@media (max-width: 1000px) {
    .header_content_info_calculate_form_input_size {
        width: 100%;
    }

    .header_content_info_calculate_form_icons {
        margin: 15px;
        cursor: pointer;
    }
    .header_content_info_calculate_button {
        width: 100%;
    }
}

@media (max-width: 1120px) {
    .header_logo_block {
        width: 30%;
    }

    .header_menu_block {
        width: 70%;
    }

    .header_content_info_calculate_form_input_size {
        min-width: 210px;
    }
}

@media (max-width: 912px) {
    .header_content_advantages_info_block {
        display: block;
    }

    .header_content_info_calculate_block {
        margin-top: 32px;
        padding-bottom: 66px;
    }
}

@media (max-width: 780px) {
    .header_content_advantages_info_block {
        width: 100%;
    }
    .header_content {
        margin-top: 100px;
    }
    .message-block {
        max-width: 100%;
    }
}

@media (max-width: 575px) {
    .header_content_info_calculate_button_block {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .header_content_info_calculate_button {
        width: 100%;
    }

    .header_content_info_calculate_result {
        display: flex;
        justify-content: center !important;
    }

    .header_content_info_calculate_result {
        margin-top: 24px;
    }
}

@media (max-width: 768px) {
    .header_content_info_calculate_result {
        gap: 12px;
    }

    .header_content_advantages_number_block {
        margin: 0 0 16px;
    }

    .header_content_info_forms {
        margin-top: 20px;
    }

    .header_content_info_forms_title {
        margin-bottom: 16px;
        font-weight: 500;
        font-size: 22px;
        line-height: 28px;
    }

    .header_content_advantages_text {
        max-width: 100%;
        margin-bottom: 20px;
        font-weight: 400;
        font-size: 16px;
        line-height: 26px;
        margin: 0;
    }

    .header_content_info_calculate_result {
        justify-content: center;
        margin: 14px 0px;
    }

    .header_content_info_calculate_forms_block {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 24px;
    }

    .front-direction-field-new_control-wrapper {
        width: 100%;
    }

    .header_content_info_calculate_result_text {
        margin: 0;
        font-weight: 300;
    }

    .header_content_info_calculate_form_icons {
        margin-left: 0;
        transform: rotate(90deg);
    }

    .header_content_advantages_block {
        flex-direction: column;
        gap: 20px;
        margin-bottom: 80px;
    }
}

@media (max-width: 480px) {
    .header_content_info_calculate_result {
        gap: 22px;
    }

    .header_content_advantages:nth-child(1) > div {
        border-top: none;
    }

    .header_content_advantages_info_block {
        margin-bottom: 0;
    }

    .header_content_advantages_number_postfix {
        font-size: 24px;
        line-height: 45px;
    }

    .header_content_advantages_block {
        margin-bottom: 40px;
    }
}
</style>
